
import { PublicationsModel } from '../models/PublicationsModel.js';
import { PublicationsView } from '../views/PublicationsView.js';

export class PublicationsController {
    constructor() {

        this.model = new PublicationsModel();
        this.view = new PublicationsView();

        this.model.subscribe(state => this.view.render(state));
    }
}